import React from "react";

const Links = () => {
  return (
    <>
      <a href="mailto:durcakk@gmail.com" rel="noreferrer" target="_blank">
        Email,
      </a>
      <a href="https://www.linkedin.com/in/jan-durcak/" rel="noreferrer" target="_blank">
        LinkedIn,
      </a>
      <a href="https://github.com/Dur4k" rel="noreferrer" target="_blank">
        GitHub,
      </a>
    </>
  );
};

export default Links;
